import angular from 'angular';
import '@app/library/PdfViewer/pdfViewer.module';
import '@common/itemCard/itemCard.module';

angular.module('eCareVault.common.carefeedBoard', [
    'eCareVault.PdfViewer',
    'eCareVault.common.itemCard'
]);
